var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSlideArrowRight = function SvgSlideArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SlideArrowRight_svg__st0",
    d: "M1.6 28c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l12.4-12.1L.9 1.9C.5 1.5.5.9.9.5s1-.4 1.4 0l13.8 13.7L2.3 27.7c-.2.2-.5.3-.7.3z"
  })));
};
export default SvgSlideArrowRight;